import React from 'react'

const SvgX = props => (
    <svg viewBox="0 0 17.8 17.8" {...props}>
        <style />
        <path
            d="M11 8.9l6.4-6.4C18 2 18 1 17.4.4s-1.5-.6-2.1 0L8.9 6.8 2.6.4C2-.1 1-.1.4.4s-.6 1.5 0 2.1l6.4 6.4-6.4 6.4c-.6.6-.6 1.5 0 2.1.6.6 1.6.6 2.2 0L8.9 11l6.4 6.4c.6.6 1.5.6 2.1 0 .6-.6.6-1.5 0-2.1L11 8.9z"
            id="Small_icons__x28_selected_x29_"
        />
    </svg>
)

export default SvgX



// WEBPACK FOOTER //
// ./src/ui/icons/X.js